/*
 * ESH Books checkout consent gate (2026-09-29).
 *
 * The Phoenix redirect script in layout/theme.liquid binds capture-phase click
 * listeners directly on the checkout button and sends the shopper to
 * secureorder.esh-books.com. Listeners registered on `window` in the capture
 * phase always run before listeners on the button itself, so this gate can stop
 * the event before Phoenix sees it.
 *
 * Loaded by snippets/esh-checkout-consent.liquid and sections/footer-utilities.liquid.
 * Markup comes from snippets/esh-checkout-consent.liquid (rendered in
 * snippets/cart-summary.liquid for both the cart page and the cart drawer).
 */
(function () {
  'use strict';
  if (window.__eshConsentGate) return;
  window.__eshConsentGate = true;

  var BUTTON_SELECTOR = '.cart__checkout-button, [data-esh-gated-checkout]';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  // Walk up from the button until we find the consent block that sits next to it.
  function findGate(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      if (node.querySelector) {
        var gate = node.querySelector('[data-esh-consent]');
        if (gate) return gate;
      }
      node = node.parentElement;
    }
    return null;
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function validate(gate) {
    var boxes = gate.querySelectorAll('input[type="checkbox"][data-esh-required]');
    var missing = [];
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var ok = box.checked;
      box.setAttribute('aria-invalid', ok ? 'false' : 'true');
      var item = closest(box, '.esh-consent__item');
      if (item) item.classList.toggle('is-invalid', !ok);
      if (!ok) missing.push(box);
    }

    var error = gate.querySelector('[data-esh-consent-error]');
    if (missing.length) {
      if (error) {
        error.textContent =
          missing.length > 1
            ? 'Please tick both boxes above to continue: agree to our policies and to the recurring membership charge.'
            : missing[0].getAttribute('data-esh-error') || 'Please tick the box above to continue.';
        error.hidden = false;
      }
      try {
        missing[0].focus({ preventScroll: true });
        missing[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (e) {
        missing[0].focus();
      }
      return false;
    }

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    return true;
  }

  function block(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function failClosed(button) {
    if (button && !button.__eshMissingNotice) {
      button.__eshMissingNotice = true;
      var p = document.createElement('p');
      p.setAttribute('role', 'alert');
      p.style.cssText = 'color:#b3261e;font-weight:600;margin:8px 0 0;font-size:13px;';
      p.textContent = 'Please refresh this page and accept our policies to continue to checkout.';
      button.insertAdjacentElement('afterend', p);
    }
  }

  // Record consent on the cart as attributes, so it travels with the cart token
  // (Phoenix receives the cart token on redirect). Best-effort only.
  function recordConsent(gate) {
    var attrs = {};
    var boxes = gate.querySelectorAll('input[type="checkbox"][data-esh-consent-key]');
    var now = new Date().toISOString();
    for (var i = 0; i < boxes.length; i++) {
      var key = boxes[i].getAttribute('data-esh-consent-key');
      var label = key === 'recurring' ? 'Recurring billing consent' : 'Policies accepted';
      attrs[label] = boxes[i].checked ? 'yes ' + now : '';
    }
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  // Clear the error message as soon as the shopper fixes it.
  document.addEventListener('change', function (event) {
    var box = event.target;
    if (!box || !box.matches || !box.matches('[data-esh-consent] input[type="checkbox"]')) return;
    var gate = closest(box, '[data-esh-consent]');
    var item = closest(box, '.esh-consent__item');
    if (box.checked) {
      box.setAttribute('aria-invalid', 'false');
      if (item) item.classList.remove('is-invalid');
      var stillMissing = gate.querySelectorAll('input[type="checkbox"][data-esh-required]:not(:checked)');
      var error = gate.querySelector('[data-esh-consent-error]');
      if (!stillMissing.length && error) {
        error.hidden = true;
        error.textContent = '';
      }
    }
    recordConsent(gate);
  });

  // Checkout button clicks (cart page + cart drawer).
  window.addEventListener(
    'click',
    function (event) {
      var button = closest(event.target, BUTTON_SELECTOR);
      if (!button) return;
      var gate = findGate(button);
      if (!gate) {
        block(event);
        failClosed(button);
        return;
      }
      if (!validate(gate)) block(event);
    },
    true
  );

  // Keyboard / implicit submits of the cart form would otherwise be caught by
  // the Phoenix navigation intercept and redirected without consent.
  window.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = (form.getAttribute('action') || '').split('?')[0].replace(/\/+$/, '');
      var isCartForm = form.id === 'cart-form' || /\/cart$/.test(action);
      if (!isCartForm) return;

      var gate = findGate(event.submitter || form);
      if (!gate) {
        var gates = document.querySelectorAll('[data-esh-consent]');
        for (var i = 0; i < gates.length; i++) {
          if (isVisible(gates[i])) {
            gate = gates[i];
            break;
          }
        }
        gate = gate || gates[0];
      }
      if (!gate) {
        block(event);
        return;
      }
      if (!validate(gate)) block(event);
    },
    true
  );
})();
